import { Button, Form, Input, Row } from 'antd';
import { updateUser } from '../../api/user';
import { getUserOrganizationAccess, verifyUserInvitation } from '../../api/organization';
import { getUserFromAccessToken, setCurrentlyActiveOrganization, setUsersOrganizationAccess } from '../../common/auth';
import RoutePaths from '../../router/RoutePaths';
import { useNavigate, useSearchParams } from 'react-router-dom';

function InvitedUserOnboarding() {
  const [initOnboardingForm] = Form.useForm();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const invitedOrgId = Number(searchParams.get('orgId'));

  interface onFinishStructure {
    fullName: string;
  }

  const onFinish = async (values: onFinishStructure) => {
    if (!invitedOrgId) {
      console.log('throw error as both are required');
      alert('Organization ID is required to verify email invitation');
      return;
    } else {
      try {
        const userToVerifyOnboard = await getUserFromAccessToken();

        // if user already has a name set we can just skip this step as the same name is used for all of the org access.
        // TODO: Split name from use and move it to the OrganizationAccess or similar table.
        if (!userToVerifyOnboard.user.fullName) {
          const updatedUser = await updateUser({ fullName: values.fullName });
        }

        await verifyUserInvitation(invitedOrgId);

        const orgAccess = await getUserOrganizationAccess();

        // Updating all the accessible orgs
        void setUsersOrganizationAccess(orgAccess.data);

        // Setting users currently active org the one you were invited by
        const currentOrg = orgAccess.data.find((org) => org.id === invitedOrgId);

        if (currentOrg) {
          void setCurrentlyActiveOrganization(currentOrg);
          navigate(RoutePaths.Home);
        } else {
          alert('No organization found. Please try again.');
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <>
      <div className="onboarding-page-wrapper">
        <h2 className="text-center h-4 mb-6">Taskonio</h2>

        <h1 className="mb-11">Set up your account</h1>

        <Row justify="center" align="middle">
          <Form
            form={initOnboardingForm}
            name="initial-onboarding"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            requiredMark="optional"
            className="w-[320px]"
          >
            <Form.Item
              label="Your name"
              name="fullName"
              rules={[
                {
                  required: true,
                  message: 'Please input your name!',
                },
              ]}
              wrapperCol={{ sm: 24 }}
              className="mb-6 text-zinc-800 text -xs font-semibold font-['Figtree'] leading-none"
            >
              <Input placeholder="Enter your full name" size="large" />
            </Form.Item>

            <Form.Item wrapperCol={{ sm: 24 }}>
              <Button type="primary" htmlType="submit" size="large" shape="round" className="w-full">
                Continue to Taskonio
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </div>
    </>
  );
}

export default InvitedUserOnboarding;
